import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {IsEmptyVar} from '../../defines/common.func';
import {LINK_TYPE, LinkInfo2, proverbSelectedId} from '../../defines/client.const';
import {Proverb, SimpleProverb} from '../../models/proverb.model';
import {ProverbBookmarkService} from '../../services/proverb/proverb-bookmark.service';
import {ProverbService} from '../../services/proverb/proverb.service';

@Component({
  selector: 'app-proverb-item',
  templateUrl: './proverb-item.component.html',
  styleUrls: ['./proverb-item.component.scss']
})
export class ProverbItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.on') get isClassOn() { return this.selected; }
  @Input() set proverb(value: SimpleProverb) {
    // console.warn('set proverb()', value.id, this.selected);
    this.detail = value as Proverb;
    if (this.selected) {
      this.loadDetail();
    }
  }
  public selected: boolean | null = null;
  @Input() set isSelected(value: boolean) {
    // console.warn('set isSelected', value, this.selected);
    if (this.selected === null || this.selected !== value) {
      this.selected = value;

      if (this.selected) {
        this.loadDetail();
      }
    }
  }

  @Output() openLink = new EventEmitter<LinkInfo2>();
  @Output() changeBookmark = new EventEmitter<boolean>();

  IsEmptyVar = IsEmptyVar;
  proverbSelectedId = proverbSelectedId;

  public detail: Proverb;
  private loaded = false;
  private loading$: Subscription = null;
  unlisten: () => void;
  private sendingBookmark = false;


  constructor(
    private renderer: Renderer2,
    private elRef: ElementRef,
    private proverbSvc: ProverbService,
    private bmSvc: ProverbBookmarkService,
  ) {
  }

  ngOnInit(): void {
    this.unlisten = this.renderer.listen(this.elRef.nativeElement, 'click', (event) => {
      const tar = event.target;
      if (tar instanceof HTMLAnchorElement && tar.className === 'wordlink') {
        event.preventDefault();
        console.log('anchor click = ', event);
        const url = decodeURI(tar.pathname);
        // alert(`text[${tar.text}] href=[${tar.getAttribute('href')}] link[${url}]`);
        const idWordLink = tar.getAttribute('href');
        this.openLink.emit({
          type: LINK_TYPE.WORD,
          id: idWordLink,
        });
      }
    });

    if (!this.loaded && this.selected) {
      this.loadDetail();
    }
  }

  ngAfterViewInit(): void {
    this.detail.offsetTop = this.elRef.nativeElement.offsetTop;
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

  private loadDetail(): void {
    if (!this.loaded && this.detail && this.loading$ === null) {
      // console.warn('loadDetail() start', this);
      this.loading$ = this.proverbSvc.GetDetail(this.detail.id).pipe(
        finalize(() => this.loading$ = null),
      ).subscribe(
        data => {
          // console.log(data);
          this.detail = data;
        },
        err => console.error(err)
      );
      this.loaded = true;
    }
    else {
      // console.warn('loadDetail() skip', this.loaded, this.detail, this.loading$);
    }
  }

  /****************************************************************************
   * 책갈피 처리
   ***************************************************************************/
  public ToggleBookmark(event: MouseEvent, proverb: Proverb): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;
    proverb.bookmark = !proverb.bookmark;
    this.bmSvc.sendBookmark(proverb.id, proverb.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
    this.changeBookmark.emit(proverb.bookmark);
  }

  public getBmCss(proverb: Proverb): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return proverb.bookmark ? 'on' : '';
  }
}
